import React, { useEffect, useState, Fragment, useRef } from 'react';
import { PageHeader } from '../../../../Common';
import { TableContentForRouteMangerPrintOption } from '../../../Common/Table/tableContent';
import services from '../services';
import InputLabel from '@material-ui/core/InputLabel';
import $ from 'jquery';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import FormHelperText from '@material-ui/core/FormHelperText';
import Joi from '@hapi/joi';
import { LoadingSpinerComponent } from '../../../../Common/loader'
import { trackPromise } from 'react-promise-tracker';
import authService from '../../../Common/services';
import tokenService from '../../../../Common/tokenDecoder';
import ReactToPrint from "react-to-print";
import { CSVLink, CSVDownload } from "react-csv";
import TextField from '@material-ui/core/TextField';
import { RouteManagerPrintOptionsObject } from '../RouteManagerPrintOptionsSchema';
import { validateProperty, validate } from "../../../Common";
import CreatePdf from './createPdf';
import _ from 'lodash';
import '../../../Common/Table/table.css';
import xlsx from 'json-as-xlsx';
import '../Pages/tableFooter.css';

const screenCode = 'ROUTEMANAGERPRINTOPTIONS';

export function RouteManagerPrintOptionsListing(props) {

    const componentRef = useRef();

    const [groups, setGroups] = useState();
    const [factories, setFactories] = useState();
    const [routes, setRoutes] = useState();
    const [errors, setErrors] = useState({})
    const [totalRow, setTotalRow] = useState({})

    const schema = Joi.object(RouteManagerPrintOptionsObject).options({ allowUnknown: true })
    const pdfRef = useRef(null);

    const [tableData, setTableData] = useState([]);
    const [footerTotal, setFooterTotal] = useState([]);

    const [searchForm, setSearchForm] = useState(
        {
            groupID: "0",
            routeID: "0",
            factoryID: "0",
            searchdate: ""
        }
    );

    const [selectedSearchValues, setSelectedSearchValues] = useState({
        group: "",
        route: "",
        factory: "",
        date: ""
    })

    const csvHeaders = [
        { label: "Reg. Number", value: "regNo" },
        { label: "Narration", value: "narration" },
        { label: "Is Master Card", value: "isOperationCardVerified" },
        { label: "Filed Gross Qunatity", value: "filedGross" },
        { label: "Filed Net Qunatity", value: "fieldNetAmount" },
        { label: "Field Tag Number", value: "fieldTagNumber" },
        { label: "Factory Tag Number", value: "factoryTagNumber" },
        { label: "Factory Gross Qunatity", value: "factoryGrossAmount" },
        { label: "Factory Net Qunatity", value: "factoryNetAmount" },
        { label: "Loss/Gain", value: "loss" }
    ];

    const [isTableHide, setIsTableHide] = useState(true);
    const [permissionList, setPermissions] = useState({
        isGroupFilterEnabled: false,
        isOperationEntityFilterEnabled: false
    });
    const initialContentRowNames = ["regNo", "isOperationCardVerified", "narration", "filedGross", "fieldNetAmount",
        "fieldTagNumber", "factoryTagNumber", "factoryGrossAmount", "factoryNetAmount", "loss"];

    useEffect(() => {
        getPermissions();
    }, []);

    useEffect(() => {
        trackPromise(
            getEsatesForDropDown()
        )
    }, [searchForm.groupID])

    useEffect(() => {
        trackPromise(
            GetAllRoutesForDropDown()
        )
    }, [searchForm.factoryID])

    async function getPermissions() {
        var permissions = await authService.getPermissionsByScreen(screenCode);
        var isAuthorized = permissions.find(p => p.permissionCode == 'VIEWROUTEMANAGERPRINTOPTIONS');

        if (isAuthorized === undefined) {
            props.history.push('/unauthorized');
        }

        var isGroupFilterEnabled = permissions.find(p => p.permissionCode == 'GROUPDROPDOWN');
        var isOperationEntityFilterEnabled = permissions.find(p => p.permissionCode == 'OPERATIONENTITYDROPDOWN');

        setPermissions({
            ...permissionList,

            isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
            isOperationEntityFilterEnabled: isOperationEntityFilterEnabled !== undefined,
        });

        var token = tokenService.getUserDetailsFromToken();
        setSearchForm({
            ...searchForm,
            groupID: token.groupID,
            factoryID: token.operationEntityID
        });

        setGroupDropDownData();
    }

    async function setGroupDropDownData() {
        const result = await services.getGroups()
        setGroups(result)
    }

    async function getEsatesForDropDown() {
        const factoryList = await services.getFactoryByGroupID(searchForm.groupID);
        setFactories(factoryList);
    }

    async function GetAllRoutesForDropDown() {
        const routeList = await services.GetAllRoutesByFactoryID(searchForm.factoryID);
        setRoutes(routeList);
    }

    function generateDropDownMenu(data) {
        let items = [];
        if (data != null) {
            for (const [key, value] of Object.entries(data)) {
                items.push(<MenuItem key={key} value={key}>{value}</MenuItem>);
            }
        }
        return items;
    }

    function handleChange(e) {
        const target = e.target
        const value = target.name === 'active' ? target.checked : target.value

        const error = { ...errors }
        const errorMessage = validateProperty(target, RouteManagerPrintOptionsObject)
        errorMessage ? error[target.name] = errorMessage : delete error[target.name]

        setSearchForm({
            ...searchForm,
            [e.target.name]: value
        });
        setErrors(error);
        clearTableRelatedData();
    }

    async function handleSearch(e) {
        e.preventDefault();
        destroyDataTable();
        setIsTableHide(true);

        setSearchDataForPdf();

        const errorMessages = validate(schema, searchForm)
        errorMessages !== null ? setErrors(errorMessages) : setErrors({})
        if (errorMessages) return;

        var reportData = await services.getReportData(searchForm);
        var result = mergeFieldAndFactoryData(reportData.factoryData, reportData.filedData);

        var total = {
            regNo: "Total",
            filedGross: 0,
            fieldNetAmount: 0,
            fieldTagNumber: 0,
            factoryGrossAmount: 0,
            factoryNetAmount: 0
        }

        result.forEach(item => {
            total.fieldTagNumber++;
            for (var record in item) {
                if (record !== "regNo" && record !== "fieldTagNumber" && record !== "narration" && record !== "loss"
                    && record !== "factoryTagNumber" && record !== "isOperationCardVerified") {
                    total[record] = total[record] + (item[record] === undefined ? 0 : item[record]);
                }
            }
        })
        setTotalRow(total)

        result.forEach(item => {
            for (var record in item) {
                if (record !== "regNo" && record !== "fieldTagNumber" && record !== "narration" && record !== "loss"
                    && record !== "factoryTagNumber" && record !== "isOperationCardVerified") {
                    item[record] = (item[record] === undefined ? (0).toFixed(2) : item[record].toFixed(2));
                }
            }
        })

        if (result.length > 1) {
            setIsTableHide(false);
            setTableData(result);
            createDataTable();
        }
    }

    function mergeFieldAndFactoryData(factoryData, filedData) {

        var result = [];
        var matchingRecords = [];

        filedData.forEach(x => {
            factoryData.forEach(y => {

                if (x.fieldTagNumber.toString() === y.factoryTagNumber.toString()) {
                    matchingRecords.push(x.fieldTagNumber.toString());
                    result.push({
                        regNo: x.fieldRegistrationNumber,
                        filedGross: x.fieldGrossAmount,
                        fieldTagNumber: x.fieldTagNumber,
                        factoryTagNumber: y.factoryTagNumber,
                        factoryGrossAmount: y.factoryGrossAmount,
                        isOperationCardVerified: x.isOperationCardVerified,
                        fieldNetAmount: x.fieldNetAmount,
                        factoryNetAmount: y.factoryNetAmount,
                        narration: x.narration,
                        loss: parseFloat(y.factoryNetAmount) - parseFloat(x.fieldNetAmount) > 0 ? "Gain" : "Loss"
                    });
                }
            });
        });
        filedData.forEach(x => {
            var res = matchingRecords.find(y => y === x.fieldTagNumber);
            if (!res) {
                var singleRecord = {
                    regNo: x.fieldRegistrationNumber,
                    filedGross: x.fieldGrossAmount,
                    fieldTagNumber: x.fieldTagNumber,
                    isOperationCardVerified: x.isOperationCardVerified,
                    fieldNetAmount: x.fieldNetAmount,
                    narration: x.narration,
                    loss: "Loss"
                }
                result.push(singleRecord);
            }
        })
        return result;
    }

    function createFile() {
        var settings = {
            sheetName: 'Route Manager Report',
            fileName: 'RouteManagerPrintOptionsReport',
            writeOptions: {}
        }
        var copyOfData = _.cloneDeep(tableData)
        copyOfData.forEach(x =>{
            x.isOperationCardVerified = x.isOperationCardVerified === true ? "Master Card" : "Customer Card"
        })
        copyOfData.push(totalRow)
        xlsx(csvHeaders, copyOfData, settings, true)
    }

    function setSearchDataForPdf() {
        setSelectedSearchValues({
            ...selectedSearchValues,
            group: groups[searchForm.groupID],
            route: routes[searchForm.routeID],
            factory: factories[searchForm.factoryID],
            date: searchForm.searchdate
        })
    }

    function destroyDataTable() {
        $('#reportTable').DataTable().destroy();
    }

    function createDataTable() {
        $('#reportTable').DataTable();
    }

    function onCancelClick() {
        setSearchForm({
            ...searchForm,
            routeID: "0",
            searchdate: ""
        });
        setErrors("");
        clearTableRelatedData();
    }

    function clearTableRelatedData() {
        setIsTableHide(true);
    }

    return (
        <Fragment>
            <LoadingSpinerComponent />
            <div className="row">
                <div className="col-md-12 card">
                    <div ref={pdfRef}>
                        <PageHeader
                            title="Route Manager Print Options Report"
                        />
                        <div className="card-body">
                            <form onSubmit={(e) => trackPromise(handleSearch(e))}>
                                <div className="form-group row">
                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="groupID">Group *</InputLabel>
                                        <Select
                                            fullWidth
                                            id="groupID"
                                            disabled={!permissionList.isGroupFilterEnabled}
                                            name="groupID"
                                            value={searchForm.groupID}
                                            onChange={(e) => handleChange(e)}>
                                            <MenuItem value="0">--Select Group--</MenuItem>
                                            {generateDropDownMenu(groups)}
                                        </Select>
                                        {errors["groupID"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["groupID"]}</FormHelperText>}
                                    </div>
                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="factoryID">Factory *</InputLabel>
                                        <Select fullWidth
                                            id="factoryID"
                                            disabled={!permissionList.isOperationEntityFilterEnabled}
                                            name="factoryID"
                                            value={searchForm.factoryID}
                                            onChange={(e) => handleChange(e)}>
                                            <MenuItem value="0">--Select factory--</MenuItem>
                                            {generateDropDownMenu(factories)}
                                        </Select>
                                        {errors["factoryID"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["factoryID"]}</FormHelperText>}
                                    </div>
                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="routeID">Route *</InputLabel>
                                        <Select fullWidth
                                            id="routeID"
                                            name="routeID"
                                            value={searchForm.routeID}
                                            onChange={(e) => handleChange(e)}>
                                            <MenuItem value="0">--Select route--</MenuItem>
                                            {generateDropDownMenu(routes)}
                                        </Select>
                                        {errors["routeID"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["routeID"]}</FormHelperText>}
                                    </div>
                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="searchdate">Date *</InputLabel>
                                        <TextField
                                            fullWidth
                                            id="searchdate"
                                            name="searchdate"
                                            type="date"
                                            onChange={(e) => handleChange(e)}
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                        />
                                    </div>
                                </div>

                                <input
                                    type="submit"
                                    disabled={validate(schema, searchForm)}
                                    className="btn btn-primary"
                                    value="Generate"
                                />
                                <input type="reset"
                                    className="btn btn-warning pull-right"
                                    value="Clear"
                                    onClick={onCancelClick}
                                />

                                {isTableHide ? null :
                                    <div>
                                        <div className="table-responsive row-top-gap">
                                            <table
                                                id="reportTable"
                                                className="display dataTable no-footer">
                                                <thead>
                                                    <tr>
                                                        <th>Reg. Number</th>
                                                        <th>Is Master Card</th>
                                                        <th>Narration</th>
                                                        <th style={{ textAlign: "right" }}>Filed Gross Qunatity</th>
                                                        <th style={{ textAlign: "right" }}>Filed Net Qunatity</th>
                                                        <th style={{ textAlign: "right" }}>Field Tag Number</th>
                                                        <th style={{ textAlign: "right" }}>Factory Tag Number</th>
                                                        <th style={{ textAlign: "right" }}>Factory Gross Qunatity</th>
                                                        <th style={{ textAlign: "right" }}>Factory Net Qunatity</th>
                                                        <th style={{ textAlign: "right" }}>Loss/Gain</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <TableContentForRouteMangerPrintOption
                                                        data={tableData}
                                                        contentRowNames={initialContentRowNames}
                                                        hasEdit={false}
                                                    />
                                                </tbody>
                                                <tfoot>
                                                    <tr>
                                                        <th colSpan={3}>Total</th>
                                                        <th style={{ textAlign: "right" }}>{totalRow.filedGross.toFixed(2)}</th>
                                                        <th style={{ textAlign: "right" }}>{totalRow.fieldNetAmount.toFixed(2)}</th>
                                                        <th></th>
                                                        <th></th>
                                                        <th style={{ textAlign: "right" }}>{totalRow.factoryGrossAmount.toFixed(2)}</th>
                                                        <th style={{ textAlign: "right" }}>{totalRow.factoryGrossAmount.toFixed(2)}</th>
                                                        <th></th>
                                                    </tr>
                                                </tfoot>
                                            </table>
                                        </div>
                                        <div className="pt-2">
                                            <ReactToPrint
                                                documentTitle={"Route Manager Print Options Report"}
                                                trigger={() => <input
                                                    type="button"
                                                    className="btn btn-primary pull-right ml-2"
                                                    value="Create PDF"
                                                />}
                                                content={() => componentRef.current}
                                            />
                                            <div hidden={true}>
                                                <CreatePdf ref={componentRef} data={tableData} total={totalRow}
                                                    rowNames={initialContentRowNames} searchData={selectedSearchValues} />
                                            </div>
                                            <input
                                                type="button"
                                                className="btn btn-primary pull-right ml-2"
                                                value="Excel"
                                                onClick={createFile}
                                            />
                                        </div>
                                    </div>
                                }
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </Fragment>
    )
}


